export const en = {
    'normal-view-title': 'Add sitelinks to your ads',
    'normal-view-title-hint': 'Shown because you have ads without sitelinks',
    'popup-view-title': 'Add sitelinks to your ad',
    'popup-view-title-hint': 'Shown because your ad has no sitelinks',
    'show-many-banner-button': 'View {count} ads',
    'show-one-banner-button': 'View {count} ad',
    'show-some-banner-button': 'View {count} ads',
    'site-links-desc1':
        'Sitelinks increase the CTR of your ads at no additional cost. If a user clicks on more than one link in your ad, you will only pay for one click.',
    'site-links-desc2':
        "Use sitelinks to tell about your offers, describe favorable delivery terms, or add other information that didn't fit into your main ad text."
};
